import { api1 } from "../utils/axiosInstance";
import { API_ENDPOINTS } from "./apiEndpoints";

export const upskillingPathwayService = {

  getUpskillingPathwayCounts: async () => {
    try {
      const response = await api1.get(API_ENDPOINTS.UPSKILLING_PATHWAY_COUNTS, {
        meta: { showToast: false }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching upskilling pathway counts:", error);
      throw error;
    }
  },

  generateUpskillingPathway: async (pathwayData) => {
    try {
      const response = await api1.post(API_ENDPOINTS.UPSKILLING_PATHWAY, pathwayData, {
        meta: { showToast: false }
      });
      return response.data;
    } catch (error) {
      console.error("Error generating upskilling pathway:", error);
      throw error;
    }
  },

  addToLearningPlan: async (pathwayId) => {
    try {
      const response = await api1.put(API_ENDPOINTS.ADD_TO_LEARNING_PLAN, {
        pathwayId
      });
      return response.data;
    } catch (error) {
      console.error("Error adding to learning plan:", error);
      throw error;
    }
  },

  getLatestPathwayId: async () => {
    try {
      const response = await api1.get(API_ENDPOINTS.GET_LATEST_PATHWAY_ID, {
        meta: { showToast: false }
      });
      return response.data;
    } catch (error) {
      console.error("Error getting latest pathway ID:", error);
      throw error;
    }
  }
};
